import React, { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

interface DataBootstrapperProps {
  children: React.ReactNode;
}

export const DataBootstrapper: React.FC<DataBootstrapperProps> = ({ children }) => {
  const { user, enhancedReady, enhancedLoading, refreshUserData } = useAuth();

  // PV2-06 (CL-P03): Single effect keyed on user.id only.
  // No re-fetch on tab focus — cacheService holds warm data between focus switches.
  // The useFocusEffect pattern it replaces was bypassing hasTriggeredLoad on every
  // focus when enhancedReady was false, causing a full refetch storm on tab switches.
  //
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (user?.id && !enhancedReady && !enhancedLoading) {
      refreshUserData();
    }
  }, [user?.id]); // Intentionally narrow: re-run only on user change, not on focus or auth-token rotation.

  // Always render children — UI components handle their own loading states.
  return <>{children}</>;
};

export default DataBootstrapper;
